import { useEventQuery } from 'shared/graphql';

/**
 * Custom hook to fetch a single event by ID using Apollo's useEventQuery.
 *
 * @param {string} id - The unique identifier of the event.
 * @returns The event data and loading state.
 */
export function useEvent(id: string) {
  const { data, loading } = useEventQuery({
    variables: { id },
  });

  return {
    data: data?.event ?? null,
    loading,
  };
}
